import * as types from "../../actions/category/types";
import * as sectionTypes from "../../actions/section/types";

const initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  id: null,
  name: null,
  sectionCount: 0,
  breadcrumbs: [],
};

export default function category(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CATEGORY_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_CATEGORY_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: true,
        id: action.category.id,
        name: action.category.name,
        sectionCount: action.category.section_count,
        breadcrumbs: action.category.breadcrumbs,
      });
    }
    case types.FETCH_CATEGORY_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }
    case sectionTypes.MOVE_SECTION_TO_SECTION_REQUEST: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount - 1 });
    }
    case sectionTypes.MOVE_SECTION_TO_SECTION_FAILURE: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount + 1 });
    }
    case sectionTypes.MOVE_SECTION_TO_CATEGORY_REQUEST: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount - 1 });
    }
    case sectionTypes.MOVE_SECTION_TO_CATEGORY_FAILURE: {
      if (!state.isLoaded) {
        return state;
      }

      return Object.assign({}, state, { sectionCount: state.sectionCount + 1 });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/category/index.js